import React from "react";
import { Box, GDSStyleObject } from "@leagueplatform/genesis-core";

type Props = {
  children: React.ReactNode;
  css?: GDSStyleObject;
  isMobile?: boolean;
};

export const OnboardingFlowContainer = ({ children, css, isMobile }: Props) => (
  <Box
    css={{
      backgroundColor: "$surfaceCardSecondary",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      padding: isMobile ? "$oneAndHalf" : "$twoAndHalf",
      boxSizing: "border-box",
      overflowY: "auto",
      height: isMobile ? "100dvh" : "",
      paddingTop: isMobile ? "104px" : "",
      ...css,
    }}
  >
    {children}
  </Box>
);
